export interface WhoamiResponse{
    agentId: number;
    busNo: number;
    expiresIn: number;
    iss: string;
    refreshTokenServerUri: string;
    resourceServerBaseUri: string;
    sub: string;
    teamId: number;
  }